module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "pt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    staticClass: "animated rotateIn",
    attrs: {
      "imaSize": 151,
      "imaSrc": "contenido/diapositiva_54",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Tips para garantizar su bienestar financiero',
      "videoEmbed": "ADMINISTRACIONDINERO54Tipsa.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('h1', {
    staticClass: "davi-curs font-red big-font"
  }, [_vm._v("Tips")]), _vm._v(" "), _c('p', [_vm._v("\n        A continuación le ofrecemos una serie de recomendaciones que serán de mucha utilidad para garantizar su\n        "), _c('span', {
    staticClass: "big-font davi-curs"
  }, [_vm._v("bienestar financiero.")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c7131ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-54.vue
// module id = 1026
// module chunks = 1